import styled from 'styled-components';

export const FieldErrorsWrapper = styled.div`
  color: ${({ theme }) => theme.color.red};
`;
